import JDSMART from './jdsmart';

var _standardStatus = function _standardStatus(platStatus) {
  var result = {};

  if (platStatus.status + '' === '1' || platStatus.status + '' === '0') {
    result['online'] = platStatus.status == '1' ? '2' : '3';
  }

  if (platStatus.device && platStatus.device.device_name) {
    result['name'] = platStatus.device.device_name;
  }

  result['status'] = {};
  platStatus.streams.forEach(function (_ref) {
    var stream_id = _ref.stream_id,
        current_value = _ref.current_value;

    if (typeof current_value === 'string' && Number(current_value) === Number(current_value)) {
      result['status'][stream_id + ''] = Number(current_value);
    } else {
      result['status'][stream_id + ''] = current_value;
    }
  });
  return result;
};

var _standardError = function _standardError(error) {
  return {
    message: error.errorInfo,
    code: error.errorCode,
    msg: error.errorInfo
  };
};

var _platformCommand = function _platformCommand(status) {
  var command = [];
  Object.keys(status).forEach(function (p) {
    command.push({
      stream_id: p,
      current_value: status[p]
    });
  });
  return {
    command: command
  };
};

var setDeviceStatus = function setDeviceStatus(status) {
  var commands = _platformCommand(status);

  return new Promise(function (resolve, reject) {
    function onSucceed(data) {
      var response = typeof data === 'string' ? JSON.parse(data) : data;

      if (response && response.streams && response.streams.length > 0) {
        resolve(_standardStatus(response));
      } else {
        resolve();
      }
    }

    function onFailed(e) {
      reject(_standardError(e));
    }

    JDSMART.io.controlDevice(commands, onSucceed, onFailed);
  });
};

var getDeviceStatus = function getDeviceStatus() {
  return new Promise(function (resolve, reject) {
    function onSucceed(data) {
      var response = typeof data === 'string' ? JSON.parse(data) : data;
      resolve(_standardStatus(response));
    }

    function onFailed(e) {
      reject(_standardError(e));
    }

    JDSMART.io.getSnapshot(onSucceed, onFailed);
  });
};

var ready = function ready() {
  return new Promise(function (resolve, reject) {
    JDSMART.ready(resolve);
  }).then(function () {
    return getDeviceStatus();
  });
};

export default {
  platform: 'jd',
  ready: ready,
  setDeviceStatus: setDeviceStatus,
  getDeviceStatus: getDeviceStatus,
  platformSDK: JDSMART
};